import { defineComponent as _defineComponent } from 'vue'
import { ref, toRefs } from 'vue';
  import BaseText from '@ui/atoms/baseText/BaseText.vue';
  import { BaseSlider } from '@ui/atoms/baseSlider';

  
  const __default__ = {
    name: 'AudioSection',
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    mute: { type: Boolean, required: true },
    volume: { type: Number, required: true }
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'change', data: { mute: boolean; volume: number }): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { mute: boolean, volume: number };

  

  const { mute, volume } = toRefs(props);

  

  const isMuted = ref(mute.value);
  const volumeValue = ref(Math.round(volume.value * 100));

  function handleMuted(mute: boolean) {
    isMuted.value = mute;
    emit('change', { mute: mute, volume: volumeValue.value / 100 });
  }

  function handleVolume(value: number) {
    volumeValue.value = value;
    emit('change', { mute: isMuted.value, volume: value / 100 });
  }

return { __sfc: true,props, mute, volume, emit, isMuted, volumeValue, handleMuted, handleVolume, BaseText, BaseSlider }
}

})